module.exports = __webpack_public_path__ + "img/img29.7c81e305.svg";